import { ContainerCampoETitulo } from "esocial.web.react.lib/cjs/components/simples/Containers";
import { TextoInstrucao, LabelObrigatorio } from "esocial.web.react.lib/cjs/components/simples/Textos";
import {
    TextField,
    Tooltip,
    IconButton
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import React, { useState } from 'react';
import { validateCNPJ, validateCAEPF, validateCNO } from "esocial.web.react.lib/cjs/utils/documentValidation";

export function CampoEstabelecimentos({
    label,
    maxWidth,
    minWidth,
    variavel,
    setVariavel,
    tooltip = false,
    tooltipText,
    multiline = false,
    bloqueado = false,
    obrigatorio = false,
    flexGrow,
    sx,
}) {
    // State for validation error
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState('');

    const handleKeyPress = (e) => {
        const char = e.data;
        if (char && !/[a-zA-Z0-9;]/.test(char)) {
            e.preventDefault();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault(); // Prevent the default paste behavior
        const pasteData = e.clipboardData.getData('text'); // Get the pasted text
        const sanitizedData = pasteData.replace(/[^;a-zA-Z0-9]/g, ''); // Remove prohibited characters
        
        const newValue = variavel + sanitizedData;
        setVariavel(newValue);
        
        // Validate after paste
        validateEstabelecimentos(newValue);
    };

    // Validate estabelecimentos on input change
    const validateEstabelecimentos = (value) => {
        if (!value) {
            setError(false);
            setHelperText('');
            return true;
        }

        // Split by semicolon and validate each entry
        const estabelecimentos = value.split(';');
        
        // Check for empty entries (consecutive semicolons or trailing semicolon)
        if (estabelecimentos.some(est => est === '')) {
            setError(true);
            setHelperText('Não deixe estabelecimentos em branco. Não use ;; nem termine com ;');
            return false;
        }

        // Validate each establishment
        for (const estabelecimento of estabelecimentos) {
            const cleanEstab = estabelecimento.replace(/[^0-9]/g, '');
            if (estabelecimento && 
                !validateCNPJ(cleanEstab) && 
                !validateCAEPF(cleanEstab) && 
                !validateCNO(cleanEstab)) {
                
                setError(true);
                setHelperText(`${estabelecimento} está com formato inválido. Verifique CNPJ, CAEPF ou CNO.`);
                return false;
            }
        }

        // If we get here, all validations passed
        setError(false);
        setHelperText('');
        return true;
    };

    // Handle input change with validation
    const handleInputChange = (e) => {
        const value = e.target.value;
        setVariavel(value);
        validateEstabelecimentos(value);
    };

    return (
        <ContainerCampoETitulo sx={{ flexGrow: { flexGrow } }}>
            <TextoInstrucao>
                {label}{obrigatorio && <LabelObrigatorio />}
                {tooltip &&
                    <Tooltip title={tooltipText}>
                        <IconButton sx={{ paddingLeft: '0.2rem', paddingTop: 0, paddingRight: 0, paddingBottom: '0.2rem' }}>
                            <HelpOutlineIcon />
                        </IconButton>
                    </Tooltip>
                }
            </TextoInstrucao>
            <TextField
                {...{
                    disabled: bloqueado,
                    inputProps: {
                        'aria-label': label,
                        'aria-required': obrigatorio,
                        readOnly: bloqueado,
                        sx: {
                            cursor: bloqueado ? 'not-allowed' : 'auto',
                        },
                        title: label,
                    },
                    onChange: handleInputChange,
                    onBeforeInput: handleKeyPress,
                    onPaste: handlePaste,
                    required: obrigatorio,
                    size: 'small',
                    sx: {
                        ...sx,
                        maxWidth: { maxWidth },
                        minWidth: { minWidth },
                        backgroundColor: bloqueado ? '#eeeeee' : 'transparent',
                        ...(multiline && { minWidth: '100%' }),
                    },
                    variant: 'outlined',
                    value: variavel || '',
                    ...(multiline && {
                        multiline: true,
                        rows: 4,
                    }),
                    error: error,
                    helperText: helperText,
                }}
            />
        </ContainerCampoETitulo>
    );
}